import { useQuery } from "@tanstack/react-query";

import { createPreviewUrl } from "@/domains/documents/repository";

/** An hour: a panel left open re-signs well before this through `staleTime`. */
const PREVIEW_URL_TTL_SECONDS = 60 * 60;
const PREVIEW_URL_STALE_MS = 50 * 60 * 1000;

/**
 * A signed URL for an attachment's tile: resized to `width` when given, the
 * original file otherwise. Cached per path and width, so reopening an issue
 * (or the same file attached to two issues) reuses the URL — and with it the
 * browser's cached image — instead of signing a fresh one.
 */
export function useAttachmentPreviewUrl(
  filePath: string,
  width: number | null,
  enabled: boolean
): { url: string | null; failed: boolean } {
  const query = useQuery({
    queryKey: ["issue-attachment-preview-url", filePath, width ?? "original"],
    queryFn: () =>
      createPreviewUrl(filePath, { width: width ?? undefined, expiresIn: PREVIEW_URL_TTL_SECONDS }),
    enabled,
    staleTime: PREVIEW_URL_STALE_MS,
    gcTime: PREVIEW_URL_STALE_MS,
    retry: 1,
  });
  return { url: query.data ?? null, failed: query.isError };
}
